export const SESSION_KEY = '1p.sessionAudit.session';
export const TABS_KEY = '1p.sessionAudit.tabs';

export const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;
export const IDLE_THRESHOLD_MS = 30 * 60 * 1000;
export const LEASE_REFRESH_MS = 5 * 1000;
export const LEASE_STALE_MS = 15 * 1000;
/**
 * `beforeunload`/`pagehide` fire identically for a real tab close and for a
 * same-tab refresh, so a session found on load is resumed rather than ended
 * on the spot. This is how long a session may sit with no heartbeat before a
 * later load treats it as abandoned (from a real close) instead of resuming
 * it. Kept comfortably below the backend's 5-minute heartbeat TTL so the
 * client reconciles it first, and comfortably above any plausible reload time.
 */
export const SESSION_STALE_MS = 3 * HEARTBEAT_INTERVAL_MS;
export const RETRY_COUNT = 3;
export const RETRY_BASE_MS = 2000;
export const ACTIVITY_THROTTLE_MS = 1000;

export const ACTIVITY_EVENTS = [
  'mousemove',
  'click',
  'keydown',
  'scroll',
  'touchstart',
] as const;

export type SessionStatus = 'creating' | 'active';
export type HeartbeatState = 'stopped' | 'active' | 'idle-paused' | 'recovering';

export interface StartSessionResponse {
  sessionId: string;
}

export interface SessionInfo {
  sessionId: string | null;
  status: SessionStatus;
  startedAt: number;
  lastHeartbeatAt: number | null;
}

export interface TabLease {
  tabId: string;
  joinedAt: number;
  lastSeenAt: number;
  lastActivityAt: number;
}

export type TabRegistry = Record<string, TabLease>;

export interface LeaderInfo {
  tabId: string | null;
  isSelf: boolean;
}
